import { HourglassBottomRounded } from '@mui/icons-material';
import { Chip, Divider, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { useMyAssortmentTranslation } from '@retail/my-assortment/i18n';
import { TrashIcon } from '@shared/custom-icons';

interface Props {
  tagName: string;
  hasEndDate?: boolean;
  /** A more compact chip, e.g. for showing selected values inside an input. */
  small?: boolean;
  onDelete?: () => void;
}

export function SubAssortmentChip({ tagName, hasEndDate, small, onDelete }: Props) {
  const { t } = useMyAssortmentTranslation();

  return (
    <Chip
      size="small"
      sx={{
        height: small ? 20 : 24,
        maxWidth: '100%',
        bgcolor: ({ palette }) => palette.info[300],
        border: ({ palette }) => `1px solid ${palette.info.main}`,
        color: ({ palette }) => palette.text.primary,
        '& .MuiChip-label': { px: small ? 0.75 : 1 },
      }}
      label={
        <Stack flexDirection="row" alignItems="center" gap={0.5}>
          {hasEndDate && (
            <HourglassBottomRounded
              sx={{ fontSize: 14, color: ({ palette }) => palette.text.secondary }}
            />
          )}
          <Typography variant="body3" noWrap>
            {tagName}
          </Typography>
          {onDelete && (
            <>
              <Divider
                orientation="vertical"
                flexItem
                sx={{ my: 0.5, borderColor: ({ palette }) => palette.info.main }}
              />
              <Tooltip title={t('myAssortment.centralAssortments.deleteFromAssortmentTag')}>
                <IconButton
                  aria-label={t('myAssortment.centralAssortments.deleteFromAssortmentTag')}
                  sx={{
                    p: 0,
                    color: ({ palette }) => palette.text.secondary,
                    '&:hover': { color: ({ palette }) => palette.text.primary },
                  }}
                  onClick={onDelete}
                >
                  <TrashIcon sx={{ fontSize: 16 }} />
                </IconButton>
              </Tooltip>
            </>
          )}
        </Stack>
      }
    />
  );
}
